<template>
    <div :class="$style.icons">
        <MKBLogo />
    </div>
</template>

<script>
import CreditCard from "../shapes/CreditCard";
import MKBLogo from "../shapes/MKBLogo";

export default {
    name: "MoscowCreditBankBlockIcons",
    components: {
        MKBLogo
    },
};
</script>

<style module lang="postcss">
.icons {
    display: flex;
    margin-top: 0;
    align-items: center;
}

.icons > svg {
    width: 130px;
    height: 55px;
}

.icons > svg:not(:last-child) {
    margin-right: 12px;
}
</style>
